import { Swiper } from 'swiper'

let defaultTab = 'consultation'
let formTabSwitch = $('.form-tab-switch')



function checkSelectedProgramm(contact_form, program)
{
  contact_form.find('[data-check-program').prop('checked', false)
  $('.js-input-from-check.input-program').val('')

  if(!program) return

  let programCheck = contact_form.find('[data-check-program="'+program+'"]')
  let programCheckVal = programCheck.data('value')
  programCheck.prop('checked', true)
  programCheck.parent().find('.js-input-from-check').val(programCheckVal)
}

$('.mfp-popup-link').magnificPopup({
  closeBtnInside: true, type: 'inline', midClick: true,
  closeMarkup: '<div class="mfp-button-wrapper"><button title="%title%" type="button" class="mfp-close">&#215;</button></div>',
  callbacks: {
    open: function () {
      let link_content = this.content
      let new_form_link_content = link_content.find('.mfp-popup-contact-form-open')
      if (new_form_link_content.length) {

        const swiper = new Swiper('.swiper-container', {
          // Optional parameters
          direction: 'horizontal',
          loop: false,
          spaceBetween: 0,
          slidesPerView: 'auto',
          watchSlidesProgress: true,
          watchSlidesVisibility: true,
        });

        //let showFormType = new_form_link_content.attr('data-form')
        let contact_form = $('#popup-contact-form')
        contact_form.find('form').hide().removeClass('active-form')
        contact_form.find('.active').removeClass('active')

        //contact_form.find('form[data-form-tab="' + showFormType + '"]').show().addClass('active-form')
        formTabSwitch.show().addClass('active-form')

        let moduleSelected = new_form_link_content.attr('data-module')
        if(moduleSelected) {
          let moduleCheck = contact_form.find('[data-check-module="'+moduleSelected+'"]')
          let moduleCheckVal = moduleCheck.data('value')
          moduleCheck.prop('checked', true)
          moduleCheck.parent().find('.js-input-from-check').val(moduleCheckVal)
        }

        new_form_link_content.on('click', function (e){
          contact_form.find('.tab-link[data-tab').removeClass('active')
          let showFormType = $(this).attr('data-form')
          contact_form.find('.tab-link[data-tab="' + showFormType + '"]').addClass('active')
        })


      }
    },
    close: function () {
      let contact_form = $('#popup-contact-form form')
      $('.js-check-to-input').prop('checked', false)
      $('.js-input-from-check').val('')
      $('#popup-contact-form').find('.error').removeClass('error').find('.visible').removeClass('visible')
      clearForm(contact_form)
    }
  }
})


$('.mfp-popup-contact-form-open').magnificPopup({
  closeBtnInside: true,
  type: 'inline',
  midClick: true,
  closeMarkup: '<div class="mfp-button-wrapper"><button title="%title%" type="button" class="mfp-close">&#215;</button></div>',
  callbacks: {
    open: function () {
      let mp = $.magnificPopup.instance
      let btn = $(mp.currItem.el[0])
      let showFormType = btn.attr('data-form')
      let selectedProgramm = btn.attr('data-program')
      let content = this.content

      const swiper = new Swiper('.swiper-container', {
        // Optional parameters
        direction: 'horizontal',
        loop: false,
        spaceBetween: 0,
        slidesPerView: 'auto'
      });

      // When opening form, close previously opened interactive course
      $('#tab-content-interactive-course').hide()

      content.find('form').closest('.contact-form').find('.contact-form-container').show()
      content.find('form').closest('.contact-form').find('.form-success').hide()
      content.removeClass('form-success-group')

      content.find('form').hide()
      content.find('.active').removeClass('active')

      formTabSwitch.show().addClass('active-form')

      content.find('.tab-link[data-tab="' + showFormType + '"]').addClass('active')
      //content.find('form[data-form-tab="' + showFormType + '"]').show().addClass('active-form')
      checkSelectedProgramm(content.find('form'), selectedProgramm)

    },
    close: function () {
      let content = this.content
      content.find('.error').removeClass('error')
      content.find('.visible').removeClass('visible')

      content.find('.js-check-to-input').prop('checked', false)
      content.find('.js-input-from-check').val('')
      clearForm(content)
      $('.to-select-2').val(0).attr("selected",true).change();
    }
  }
})

$('body').on('click', '.contact-tabs-switch .tab-link', function (e) {
  e.preventDefault()
  let showFormType = $(this).attr('data-tab')
  let contact_form = $(this).closest('.contact-form')

  formTabSwitch.show().addClass('active-form')
  $('.contact-tabs-switch').scrollLeft(400);

  if (showFormType == 'interactive') {
    $('.form-tab-switch').hide()
    $('#tab-content-interactive-course').show()
  } else {
    $('#tab-content-interactive-course').hide()
  }

  contact_form.find('form').hide().removeClass('active-form')
  contact_form.find('.active').removeClass('active')
  contact_form.find('.tab-link[data-tab="' + showFormType + '"]').addClass('active')
  //contact_form.find('form[data-form-tab="' + showFormType + '"]').show().addClass('active-form')

})

$('body').on('click', '.form-tab-switch .tab-link', function (e) {
  e.preventDefault()

  $(this).parent().hide()
  let showFormType = $(this).attr('data-tab')
  let showContactType = $('.contact-tabs-switch .tab-link.active').attr('data-tab')
  let contact_form = $(this).closest('.contact-form')

  contact_form.find('form').hide().removeClass('active-form')
  contact_form.find('form[data-form-tab="' + showContactType + '-' + showFormType + '"]').show().addClass('active-form')
})

$('body').on('click', '.changeable-link', function (e) {
  e.preventDefault()
  let showFormType = $(this).attr('data-tab')
  let showContactType = $('.contact-tabs-switch .tab-link.active').attr('data-tab')
  let contact_form = $(this).closest('.contact-form')
  contact_form.find('form').hide().removeClass('active-form')
  contact_form.find('form[data-form-tab="' + showContactType + '-' + showFormType + '"]').show().addClass('active-form')
})

$('body').on('change', '.js-check-to-input', function (e){
  e.preventDefault()
  let input = $(this).parent().find('.js-input-from-check')
  input.val('')
  if($(this).is(':checked')) {
    input.val($(this).data('value'))
  }
})

let select2Selects = $('.to-select-2')
if (select2Selects.length) {
  select2Selects.each(function (k, v) {
    let placeholder = $(this).attr('data-placeholder')
    $(this).select2({
      placeholder: placeholder,
      selectOnClose: true,
      minimumResultsForSearch: -1
    })
  })

}

$('body').on('mouseenter', '.form-field.with-tooltip label', function (e) {
  let label = $(this)
  let tooltip = label.parent().find('.form-field-tooltip')
  //tooltip.addClass('visible')
})
$('body').on('mouseleave', '.form-field.with-tooltip label', function (e) {
  let label = $(this)
  let tooltip = label.parent().find('.form-field-tooltip')
 // tooltip.removeClass('visible')
})


$('body').on('keyup', 'input', function (e) {


  if ($(this).attr('name') === 'code') {
    if ($(this).val().length === $(this).attr("maxlength")) {
      $(this).next().focus();
    }
    let $value = $(this).val()
    let $numberValue = $value.replace(/[^0-9.]/g, '')
    $(this).val($numberValue)

  }
})

$('body').on('change', '.to-select-2', function (e) {
  let $selectedValue = $('.to-select-2 :selected').val()

  $('#dynamic-form-fields').empty()
  for (let i = 0; i < $selectedValue; i++) {
    let nextI = i + 1
    if ($selectedValue == 1) {
      $('#dynamic-form-fields').append(shortForm)
      $('.form-filed-id').html(nextI + '.')
    }

    if ($selectedValue > 1 && $selectedValue <= 3) {
      $('#dynamic-form-fields').append(shortForm)

      $('#dynamic-form-fields .js-form-filed-id').html(nextI + '.')
      $('#dynamic-form-fields .js-form-filed-id').removeClass('js-form-filed-id')
      $('#dynamic-form-fields').find('.form-group').addClass('disabled')
      $('#dynamic-form-fields').find('.form-group:first-child').removeClass('disabled').addClass('not-disabled')
      $('#dynamic-form-fields').find('.disabled').find('input').attr('disabled', true)

    }

    if ($selectedValue > 3) {

      $('#dynamic-form-fields').append(longForm)
      $('#dynamic-form-fields .js-title').html(nextI + '. ' + $('#dynamic-form-fields').attr('data-translation-person'))
      $('#dynamic-form-fields .js-title').removeClass('js-title')

      $('#dynamic-form-fields').find('.form-group').addClass('disabled')
      $('#dynamic-form-fields').find('.form-filed-id').removeClass('js-open-accordion-form')
      $('#dynamic-form-fields').find('.form-group:first-child')
        .removeClass('disabled')
        .addClass('not-disabled opened')
        .find('.form-filed-id').addClass('js-open-accordion-form')

      //$('#dynamic-form-fields').find('.disabled').find('input').attr('disabled', true)
    }

    let allFormGroups = $('.form-group')
    allFormGroups.each(function (key, item) {

      let inputs = $(this).find('input')

      inputs.each(function (i_key, i_item){

        $(this).attr('id', 'tab-1-person-' + key+'-'+i_key)
        $(this).attr('for', 'tab-1-person-' + key+'-'+i_key)

        let name = $(i_item).attr('data-name')
        let newName = 'person' + '[' + key + ']' + '['+name+']'
        $(this).attr('name', newName)

      })

    })
  }

  function areAllAvailableInputsFilled() {
    let allAvailableInputs = $('.form-group.not-disabled input')
    let validated = 1

    allAvailableInputs.each(function (k, item) {
      if (!$(item).val()) {
        validated = 0
      }
    })

    return validated > 0
  }

  function availableInputsOnChange() {
    let allAvailableInputs = $('.form-group.not-disabled input')
    allAvailableInputs.each(function (k, item) {
      $(this).on('change', function (e) {
        if (areAllAvailableInputsFilled()) {
          ifSuccess()
        }
      })
    })
  }

  availableInputsOnChange()

  function ifSuccess() {
    $('.form-group.disabled').first()
      .removeClass('disabled')
      .addClass('not-disabled opened')
      .find('input').attr('disabled', false)
      .parent().parent().parent().parent().find('.form-filed-id').addClass('js-open-accordion-form')

    availableInputsOnChange()
  }
})

let personTranslation = $('#dynamic-form-fields').attr('data-translation-person')

$('body').on('click', '.js-delete-form-group-popup', function (e) {
  $('#popup-delete-form-group').removeClass('mfp-hide')
  let $groupID

  if ($(this).parent().hasClass('form-group-accordion')) {
    let $groupIDText = $(this).parent().find('.form-filed-id  div').html()
    let replaceString = '/[\.' + personTranslation + '.*$]/g'
    $groupID = $groupIDText.replace(/[\.cilvēks.*$]/g, '')

  } else {

    $groupID = $(this).parent().find('.form-filed-id').html()
  }


  $('body').on('click', '.confirm-delete-form .btn-cancel', function (e) {
    $('#popup-delete-form-group').addClass('mfp-hide')

  })

  $('body').on('click', '.confirm-delete-form .btn-approve', function (e) {
    let allGroups = $('.form-group')
    allGroups.each(function (k, item) {

      let $allIds

      if ($(this).hasClass('form-group-accordion')) {
        let $allIdsText = $(this).find('.form-filed-id div ').html()
        $allIds = $allIdsText.replace(/[\.cilvēks.*$]/g, '')
      } else {

        $allIds = $(this).find('.form-filed-id').html()
      }


      if ($allIds == $groupID) {
        $(this).remove()
        $('#popup-delete-form-group').addClass('mfp-hide')
        $groupID = 0
        $allIds = 0
        if (areAllAvailableInputsFilled()) {
          ifSuccess()
        }

        let $newSelected = allGroups.length - 1
        $('.to-select-2').select2('destroy');
        $('.to-select-2').val($newSelected).select2();
      }
    })

    let allGroupsAfterDelete = $('#dynamic-form-fields .form-group')
    allGroupsAfterDelete.each(function (k, item) {

      if ($(this).hasClass('form-group-accordion')) {
        $(this).find('.form-filed-id div').html(k + 1 + '. ' + $('#dynamic-form-fields').attr('data-translation-person'))

        if (k == 0) {
          $(this).removeClass('disabled').addClass('not-disabled opened').find('.form-filed-id').addClass('js-open-accordion-form')
          $(this).find('input').attr('disabled', false)

        }
      } else {
        $(this).find('.form-filed-id').html(k + 1 + '.')
        if (k == 0) {
          $(this).removeClass('disabled').addClass('not-disabled').find('input').attr('disabled', false)
        }
      }
    })

    function areAllAvailableInputsFilled() {

      let allAvailableInputs = $('#dynamic-form-fields .form-group.not-disabled input')
      let validated = 1

      allAvailableInputs.each(function (k, item) {
        if (!$(item).val()) {
          validated = 0
        }
      })

      return validated > 0
    }

    function availableInputsOnChange() {
      let allAvailableInputs = $('#dynamic-form-fields .not-disabled input')
      allAvailableInputs.each(function (k, item) {
        $(this).on('change', function (e) {
          if (areAllAvailableInputsFilled()) {
            ifSuccess()
          }
        })
      })
    }

    availableInputsOnChange()

    function ifSuccess() {
      $('.form-group.disabled').first()
        .removeClass('disabled')
        .addClass('not-disabled opened')
        .find('input').attr('disabled', false)
        .parent().parent().parent().parent().find('.form-filed-id').addClass('js-open-accordion-form')

      availableInputsOnChange()
    }
  })
})


$('body').on('click', '.js-open-accordion-form', function (e) {
  $(this).next().toggle()
  $(this).parent().parent().toggleClass('opened')
})

$('body').on('keyup', '#tab-1-row-2', function (e){
  if($(this).val().length >= 6) {
    $('#tab-1-row-2-2').focus()
  }
})
$('body').on('keyup', '[data-name="code1"]', function (e){
  if($(this).val().length >= 6) {
    let closestVal = $(this).closest('.personal-code-wrapper').find('[data-name="code2"]')
    closestVal.focus()
  }
})

if($(window).width() < 600) {
  $('.to-select-2').removeClass('select2-hidden-accessible')
  $('.select2').hide()
}

